<dx-select-box [dataSource]="countryList"
               [value]="country"
               (valueChange)="itemChange($event)"
               [disabled]="disabled"
               [searchEnabled]="true"
               [showClearButton]="true">
</dx-select-box>
